/*
 * A butterfly, and the marigold divider used under every heading.
 */

/** A butterfly; its wings beat in CSS (.ut-butterfly__wing). viewBox -20 -16 40 32. */
export const Butterfly = ({ className = "", colors = ["#f06292", "#ffb300"] }) => (
  <svg className={`ut-butterfly ${className}`} viewBox="-20 -16 40 32" aria-hidden="true" overflow="visible">
    <g className="ut-butterfly__wing ut-butterfly__wing--l">
      <path d="M-1,-1 C-8,-16 -20,-14 -18,-4 C-17,2 -8,2 -1,0 Z" fill={colors[0]} />
      <path d="M-1,1 C-8,2 -15,8 -11,13 C-7,16 -3,9 -1,2 Z" fill={colors[1]} />
      <circle cx="-11" cy="-6" r="2" fill="#fff" opacity="0.7" />
    </g>
    <g className="ut-butterfly__wing ut-butterfly__wing--r">
      <path d="M1,-1 C8,-16 20,-14 18,-4 C17,2 8,2 1,0 Z" fill={colors[0]} />
      <path d="M1,1 C8,2 15,8 11,13 C7,16 3,9 1,2 Z" fill={colors[1]} />
      <circle cx="11" cy="-6" r="2" fill="#fff" opacity="0.7" />
    </g>
    <ellipse rx="1.3" ry="7" fill="#3a2a22" />
    <path d="M0,-6 C-2,-10 -4,-12 -6,-13 M0,-6 C2,-10 4,-12 6,-13" fill="none" stroke="#3a2a22" strokeWidth="0.7" />
  </svg>
);

/** Gold rule with a marigold at its centre, under every heading. */
export const MarigoldDivider = ({ className = "" }) => (
  <div className={`ut-divider ${className}`} aria-hidden="true">
    <span className="ut-divider__rule" />
    <svg className="ut-divider__flower" viewBox="-12 -12 24 24">
      <use href="#ut-marigold" x="-11" y="-11" width="22" height="22" />
    </svg>
    <span className="ut-divider__rule" />
  </div>
);
